// extracted by mini-css-extract-plugin
module.exports = {"underline-offset-9":"pure_underline-offset-9__CebsM","w-fit":"pure_w-fit__eTUof","basis-6":"pure_basis-6__FRzy9"};